import RemoteFilters from 'frontcore/presentation/remote-filters/views/RemoteFilters.vue'
import { DASHBOARD_MODULE_TOKENS } from 'frontend/constants/settings'
import { SKILL_MATRIX_SOURCE } from 'frontend/constants/skillMatrix'
import { VS } from 'frontend/constants/callers'

const HeaderFactoryStructure = () => import('frontend/components/core/HeaderFactoryStructure')
const ILUMatrixOverviewPage = () => import('frontend/pages/skillMatrix/ILUMatrixOverviewPage')
const SkillMatrixPage = () => import('frontend/pages/skillMatrix/SkillMatrixPage')
const SkillMatrixThresholdsPage = () => import('frontend/pages/skillMatrix/SkillMatrixThresholdsPage')
const SkillsHistoryPage = () => import('frontend/pages/skillMatrix/SkillsHistoryPage')
const StandardILUMatrixPage = () => import('frontend/pages/skillMatrix/StandardILUMatrixPage')
const SkillMatrixBasePage = () => import('frontend/pages/skillMatrix/SkillMatrixBasePage')

export default [
  {
    path: '/skill-matrix',
    name: DASHBOARD_MODULE_TOKENS.skillMatrix.name,
    redirect: { name: DASHBOARD_MODULE_TOKENS.skillMatrixOverview.name },
    component: SkillMatrixPage,
    props: { caller: VS },
    children: [
      {
        shownInMenu: true,
        path: 'overview',
        name: DASHBOARD_MODULE_TOKENS.skillMatrixOverview.name,
        components: {
          default: ILUMatrixOverviewPage,
          header: HeaderFactoryStructure,
        },
        props: {
          default: { caller: VS, source: SKILL_MATRIX_SOURCE },
          header: { caller: VS },
        },
      },
      {
        shownInMenu: true,
        path: 'matrix',
        name: DASHBOARD_MODULE_TOKENS.skillMatrixList.name,
        redirect: { name: DASHBOARD_MODULE_TOKENS.skillMatrixList.children.skills },
        components: {
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
          default: SkillMatrixBasePage,
        },
        props: {
          header: { caller: VS },
        },
        children: [
          {
            path: 'skills',
            name: DASHBOARD_MODULE_TOKENS.skillMatrixList.children.skills,
            component: StandardILUMatrixPage,
            props: {
              caller: VS,
              source: SKILL_MATRIX_SOURCE, matrixType: 'skills',
              selectedTab: DASHBOARD_MODULE_TOKENS.skillMatrixList.children.skills,
            },
          },
          {
            path: 'certifications',
            name: DASHBOARD_MODULE_TOKENS.skillMatrixList.children.certifications,
            component: StandardILUMatrixPage,
            props: {
              caller: VS,
              source: SKILL_MATRIX_SOURCE, matrixType: 'certifications',
              selectedTab: DASHBOARD_MODULE_TOKENS.skillMatrixList.children.certifications,
            },
          },
        ],
      },
      {
        shownInMenu: false,
        path: 'thresholds',
        name: DASHBOARD_MODULE_TOKENS.skillMatrixList.children.thresholds,
        component: SkillMatrixThresholdsPage,
        props: {
          default: { caller: VS, source: SKILL_MATRIX_SOURCE },
        },
      },
      {
        shownInMenu: false,
        path: 'history/standards/:standardID/operators/:operatorID',
        name: 'skill-matrix-standard-history',
        components: {
          default: SkillsHistoryPage,
        },
        props: {
          default: { caller: VS, source: SKILL_MATRIX_SOURCE },
        },
      },
      {
        shownInMenu: false,
        path: 'history/perimeters/:perimeterID/operators/:operatorID',
        name: 'skill-matrix-perimeter-history',
        components: {
          default: SkillsHistoryPage,
        },
        props: {
          default: { caller: VS, source: SKILL_MATRIX_SOURCE },
        },
      },
    ],
  },
]
